module.exports = __webpack_public_path__ + "img/qihang.ca8d5c25.png";